// in src/posts.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  SelectInput,
  ChipField,
  SingleFieldList,
  FormTab,
  TabbedForm,
  NumberField,
  NumberInput,
  DateField,
  ReferenceArrayField,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceField,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

const OngoingProjectFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="description" alwaysOn />
  </Filter>
);

const EntryTitle = ({ record }) => {
  return <span>Project: {record ? `${record.description}` : ""}</span>;
};

export const OngoingProjectListAdmin = (props) => (
  <List {...props} filters={<OngoingProjectFilter />} exporter={false} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="description" />
      <ReferenceArrayField label="Areas" reference="areas" source="areas">
        <SingleFieldList linkType={false}>
          <ChipField source="description" />
        </SingleFieldList>
      </ReferenceArrayField> 
      <ReferenceField
        label="Phase"
        source="phase"
        reference="phases"
        linkType={false}
      >
        <ChipField source="description" />
      </ReferenceField>
      <RichTextField source="warnings" />
      <RichTextField source="suggestions" />
      <DateField label="Last Update" source="lastupdate" locales="lt" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);
export const OngoingProjectList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<OngoingProjectFilter />}
    exporter={false}
  >
    <Datagrid>
      <TextField source="description" />
      <ReferenceArrayField label="Areas" reference="areas" source="areas">
        <SingleFieldList linkType={false}>
          <ChipField source="description" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceField
        label="Phase"
        source="phase"
        reference="phases"
        linkType={false}
      >
        <ChipField source="description" />
      </ReferenceField>
      <RichTextField source="warnings" />
      <RichTextField source="suggestions" />
      <DateField label="Last Update" source="lastupdate" locales="lt" />
      <ShowButton label="" />
    </Datagrid>
  </List>
);

export const OngoingProjectShow = (props) => (
  <Show title={<EntryTitle />} {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextField source="id" />
        <TextField source="description" />
        <NumberField source="duration" label="Duration (months)" />
        <ReferenceField
          label="Phase"
          source="phase"
          reference="phases"
          linkType={false}
        >
          <ChipField source="description" />
        </ReferenceField>
      </FormTab>
      <FormTab label="Areas">
        <ReferenceArrayField label="Areas" reference="areas" source="areas">
          <SingleFieldList linkType={false}>
            <ChipField source="description" />
          </SingleFieldList>
        </ReferenceArrayField>
      </FormTab>
      <FormTab label="Warnings">
        <RichTextField source="warnings" />
      </FormTab>
      <FormTab label="Suggestions">
        <RichTextField source="suggestions" />
      </FormTab>
      <FormTab label="Status">
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Show>
);

export const OngoingProjectCreate = (props) => (
  <Create {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextInput source="id" label="Id" />
        <TextInput source="description" />
        <NumberInput source="duration" label="Duration (months)" />
        <ReferenceArrayInput
          label="Areas"
          source="areas"
          reference="areas"
          perPage={100}
        >
          <SelectArrayInput optionText="description" />
        </ReferenceArrayInput>
      </FormTab>
      <FormTab label="Phases">
        <ReferenceInput label="Phase" source="phase" reference="phases">
          <SelectInput optionText="description" />
        </ReferenceInput>
      </FormTab>
      <FormTab label="Warnings">
        <RichTextInput source="warnings" />
      </FormTab>
      <FormTab label="Suggestions">
        <RichTextInput source="suggestions" />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const OngoingProjectEdit = (props) => (
  <Edit title={<EntryTitle />} {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextInput source="description" />
        <NumberInput source="duration" label="Duration (months)" />
        <ReferenceInput label="Phase" source="phase" reference="phases">
          <SelectInput optionText="description" />
        </ReferenceInput>

        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
      <FormTab label="Areas">
        <ReferenceArrayInput
          label="Areas"
          source="areas"
          reference="areas"
          perPage={100}
        >
          <SelectArrayInput optionText="description" />
        </ReferenceArrayInput>
      </FormTab>
      <FormTab label="Warnings">
        <RichTextInput source="warnings" />
      </FormTab>
      <FormTab label="Suggestions">
        <RichTextInput source="suggestions" />
      </FormTab>
      <FormTab label="Status">
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/ongoingProjects.js